import { handleActions } from "redux-actions";
import { MERCHANT } from "constants/action-types";
import { IQuery, IMutate, RequestStatus } from "constants/crud";
import {
    ListCollectionVersionStatutesRequestAction,
    ListCollectionVersionStatusesCompleteAction,
    CreateCollectionVersionStatusRequestAction,
    CreateCollectionVersionStatusCompleteAction,
    UpdateCollectionVersionStatusRequestAction,
    UpdateCollectionVersionStatusCompleteAction,
    RemoveCollectionVersionStatusRequestAction,
    RemoveCollectionVersionStatusCompleteAction,
} from "actions/merchant";
import { ICollectionVersionStatus } from "helpers/collection-version-status";

interface IListState extends IQuery<ICollectionVersionStatus[]> {}
interface ISingleState extends IMutate<ICollectionVersionStatus> {}

export interface IState {
    list: IListState;
    single: ISingleState;
}

const initialState: IState = {
    list: {
        queryError: undefined,
        queryStatus: RequestStatus.Active,
        result: [],
    },
    single: {
        mutateStatus: RequestStatus.Idle,
        mutateError: undefined,
        result: undefined,
    },
};

export const merchantCollectionVersionStatus = handleActions<IState, any>(
    {
        [MERCHANT.COLLECTION_VERSION_STATUS.LIST.REQUEST]: (
            state: IState,
            _action: ListCollectionVersionStatutesRequestAction
        ): IState => {
            return {
                ...state,
                list: {
                    ...initialState.list,
                },
            };
        },
        [MERCHANT.COLLECTION_VERSION_STATUS.LIST.COMPLETE]: (
            state: IState,
            action: ListCollectionVersionStatusesCompleteAction
        ): IState => {
            return {
                ...state,
                list: {
                    ...state.list,
                    queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                    queryError: action.payload instanceof Error ? action.payload : undefined,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
            };
        },
        [MERCHANT.COLLECTION_VERSION_STATUS.CREATE.REQUEST]: (
            state: IState,
            action: CreateCollectionVersionStatusRequestAction
        ): IState => {
            const existing = [...(state.list.result || [])];
            existing[action.payload.index] = action.payload.collectionVersionStatus as ICollectionVersionStatus;
            return {
                ...state,
                list: {
                    ...state.list,
                    result: existing,
                },
                single: {
                    ...initialState.single,
                    mutateStatus: RequestStatus.Active,
                    mutateError: undefined,
                },
            };
        },
        [MERCHANT.COLLECTION_VERSION_STATUS.CREATE.COMPLETE]: (
            state: IState,
            action: CreateCollectionVersionStatusCompleteAction
        ): IState => {
            return {
                ...state,
                list: {
                    ...state.list,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                },
            };
        },
        [MERCHANT.COLLECTION_VERSION_STATUS.UPDATE.REQUEST]: (
            state: IState,
            _action: UpdateCollectionVersionStatusRequestAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateStatus: RequestStatus.Active,
                    mutateError: undefined,
                },
            };
        },
        [MERCHANT.COLLECTION_VERSION_STATUS.UPDATE.COMPLETE]: (
            state: IState,
            action: UpdateCollectionVersionStatusCompleteAction
        ): IState => {
            return {
                ...state,
                list: {
                    ...state.list,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                },
            };
        },
        [MERCHANT.COLLECTION_VERSION_STATUS.SORT.COMPLETE]: (
            state: IState,
            action: UpdateCollectionVersionStatusCompleteAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                },
            };
        },
        [MERCHANT.COLLECTION_VERSION_STATUS.REMOVE.REQUEST]: (
            state: IState,
            _action: RemoveCollectionVersionStatusRequestAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateStatus: RequestStatus.Active,
                    mutateError: undefined,
                },
            };
        },
        [MERCHANT.COLLECTION_VERSION_STATUS.REMOVE.COMPLETE]: (
            state: IState,
            action: RemoveCollectionVersionStatusCompleteAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                },
            };
        },
    } as any,
    initialState
);
